import { Trans, t } from "@web-monorepo/i18n/macro";
import { DDSToast } from "@web-monorepo/dds";
import { useAfterUnmount, useSideEffectOnMount } from "@web-monorepo/hooks";
import { clsx } from "clsx";
import { toast } from "react-toastify";
import { Group } from "src/pods/groups";
import logEvent from "src/utils/logEvent";
import styles from "./GroupsDisplay.module.css";

type GroupsDisplayProps = {
  groups?: Group[];
  baseAvatarURL?: string | null;
  isReceiver?: boolean;
};

export default function GroupsDisplay({ groups, baseAvatarURL, isReceiver }: GroupsDisplayProps) {
  useSideEffectOnMount(() => {
    logEvent({ eventName: "groupcreator.result.open" });
    if (groups?.length) {
      toast(<DDSToast variant="success" text={t`Groups created successfully`} />);
    }
  });

  // Unmount cleanup: matches the pre-migration componentWillUnmount.
  useAfterUnmount(() => {
    logEvent({ eventName: "groupcreator.result.close" });
  });

  return (
    <div className={styles.groups}>
      {groups?.map((group, idx) => (
        <section key={idx} className={styles.card} role="status" aria-live="polite">
          <p className={styles.groupTitle}>
            <Trans>Group {{ groupNumber: idx + 1 }}</Trans>
          </p>
          {group.students.map((student) => {
            const lastLetter = student.lastName.slice(0, 1);
            return (
              <div key={student._id} className={styles.student}>
                <img className={styles.avatar} src={`${baseAvatarURL || ""}${student.avatar}`} alt="" />
                <p className={clsx(styles.name, isReceiver && styles.nameReceiver)}>
                  {student.firstName} {lastLetter}.
                </p>
              </div>
            );
          })}
        </section>
      ))}
    </div>
  );
}
